import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { DetachedLiveViewerWindow, DetachedShareControllerWindow, DetachedSharePickerWindow } from "./liveWindows";
import { AuthProvider } from "./auth";
import { RealtimeProvider } from "./realtime";
import { VoiceProvider } from "./voice";
import { registerServiceWorker } from "./pwa";
import "./styles.css";
import "./liveWindows.css";

const standaloneDisplay = window.matchMedia("(display-mode: standalone)");
const fullscreenDisplay = window.matchMedia("(display-mode: fullscreen)");
const syncDisplayMode = () => {
  const iosStandalone = (navigator as Navigator & { standalone?: boolean }).standalone === true;
  document.documentElement.classList.toggle("standalone-mode", standaloneDisplay.matches || fullscreenDisplay.matches || iosStandalone);
};

syncDisplayMode();
standaloneDisplay.addEventListener?.("change", syncDisplayMode);
fullscreenDisplay.addEventListener?.("change", syncDisplayMode);

registerServiceWorker();

const liveWindowMode = new URLSearchParams(window.location.search).get("desktopWindow");
document.documentElement.classList.toggle("live-window-mode", Boolean(liveWindowMode));
ReactDOM.createRoot(document.getElementById("root")!).render(
  liveWindowMode === "live-viewer" ? <AuthProvider><RealtimeProvider><DetachedLiveViewerWindow /></RealtimeProvider></AuthProvider> :
  liveWindowMode === "share-picker" && window.verseDesktop ? <DetachedSharePickerWindow /> :
  liveWindowMode === "share-controller" && window.verseDesktop ? <DetachedShareControllerWindow /> :
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <RealtimeProvider>
          <VoiceProvider>
            <App />
          </VoiceProvider>
        </RealtimeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
